<template>
  <div class="paint-box" :style="getCustomStyle(startGameConfig)">
    <div class="row justify-content-between wrapper">
      <div class="col-1 paint-bar-left">
        <div class="row justify-content-center">
          <input type="radio" id="pen" name="options" autocomplete="off" @change="changeOption" checked />
          <label for="pen"> <img src="../img/pen.png" /> </label>
        </div>
        <div class="row justify-content-center">
          <input type="radio" id="erase" name="options" autocomplete="off" @change="changeOption" />
          <label for="erase"> <img src="../img/erase.png" /> </label>
        </div>
        <div class="row justify-content-center">
          <div class="sizePen">
            <input
              type="radio"
              id="x1"
              name="sizePen"
              autocomplete="off"
              @change="changeSizePen"
              value="6"
              :checked="startGameConfig.sizePen == 6"
            />
            <label for="x1"> <img src="../img/x1.png" /> </label>
            <input
              type="radio"
              id="x2"
              name="sizePen"
              autocomplete="off"
              @change="changeSizePen"
              value="10"
              :checked="startGameConfig.sizePen == 10"
            />
            <label for="x2"> <img src="../img/x2.png" /> </label>
            <input
              type="radio"
              id="x3"
              name="sizePen"
              autocomplete="off"
              @change="changeSizePen"
              value="14"
              :checked="startGameConfig.sizePen == 14"
            />
            <label for="x3"> <img src="../img/x3.png" /> </label>
            <input
              type="radio"
              id="x4"
              name="sizePen"
              autocomplete="off"
              @change="changeSizePen"
              value="18"
              :checked="startGameConfig.sizePen == 18"
            />
            <label for="x4"> <img src="../img/x4.png" /> </label>
            <input
              type="radio"
              id="x5"
              name="sizePen"
              autocomplete="off"
              @change="changeSizePen"
              value="22"
              :checked="startGameConfig.sizePen == 22"
            />
            <label for="x5"> <img src="../img/x5.png" /> </label>
            <input
              type="radio"
              id="x6"
              name="sizePen"
              autocomplete="off"
              @change="changeSizePen"
              value="26"
              :checked="startGameConfig.sizePen == 26"
            />
            <label for="x6"> <img src="../img/x6.png" /> </label>
          </div>
        </div>
      </div>
      <div class="col-1 paint-bar-right">
        <div v-for="(color, index) in startGameConfig.colors" :key="color">
          <input
            type="radio"
            :id="'color_' + index"
            :value="color"
            name="colors"
            autocomplete="off"
            @change="changeColor"
            :checked="index == 0"
          />
          <label :for="'color_' + index">
            <div
              class="colors"
              :style="{
                backgroundColor: color,
                backgroundImage:
                  'radial-gradient(circle at right top, rgba(255,255,255,0.2), ' + color + ' 40%, rgba(0,0,0,0.3))',
              }"
            ></div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import * as utils from '../../../Utils/inputUtils';
import defaultMixins from '../../../mixins/defaultMixin';
import { PanelDraw } from '../js/panelDraw';

export default {
  name: 'mp-paint',
  mixins: [defaultMixins],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    panel: {
      type: Object,
      default: function () {
        return new PanelDraw(this.startGameConfig);
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.panel);
  },
  methods: {
    changeSizePen(val) {
      this.panel.size = val.target.value;
      this.$emit('changeConfig', { panel: this.panel });
    },
    changeColor(val) {
      this.panel.changeColor({
        val: val.target.value,
      });
      this.$emit('changeConfig', { panel: this.panel });
    },
    changeOption(val) {
      switch (val.target.id) {
        case 'erase':
          this.panel.erase = true;
          break;
        default:
          this.panel.erase = false;
          break;
      }
      this.$emit('changeConfig', { panel: this.panel });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({}, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="sass"></style>
<style lang="sass" scoped>
@mixin centre($axis: "both")
	position: absolute
	@if $axis == "y"
    top: 50%
    -webkit-transform: translateY(-50%)
    -moz-transform: translateY(-50%)
    -ms-transform: translateY(-50%)
    -o-transform: translateY(-50%)
    transform: translateY(-50%)
	@if $axis == "x"
		left: 50%
    -webkit-transform: translateX(-50%)
    -moz-transform: translateX(-50%)
    -ms-transform: translateX(-50%)
    -o-transform: translateX(-50%)
    transform: translateX(-50%)
	@if $axis == "both"
		top: 50%
		left: 50%
		-webkit-transform: translate(-50%, -50%)
    -moz-transform: translate(-50%, -50%)
    -ms-transform: translate(-50%, -50%)
    -o-transform: translate(-50%, -50%)
    transform: translate(-50%, -50%)

label
  display: inline-block
label:hover
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5)
input[type="radio"]
  opacity: 0
  position: fixed
  width: 0
input[type="radio"]:checked + label
  background: #c0c0c0

.paint-bar-left, .paint-bar-right
  z-index: 10000
  background: #e6e6e6
  max-width: 85px
  padding: 15px
  @include centre(y)
  .row
    margin-left: auto
    margin-right: auto

.paint-bar-left
  padding-left: 0px
  border-radius: 0px 25px 25px 0px
  .sizePen
    background-image: url("../img/bgrSize.png")
    background-position: 25px 0px
    background-repeat: no-repeat
    background-size: 40px 100%;
    label
      margin-bottom: 0
      img
        padding-left: 25px
  label
    border-radius: 0px 25px 25px 0px
    img
      padding: 4px 4px 4px 20px
      width: 100%
  input[type="radio"]
    border-radius: 0px 25px 25px 0px

.paint-bar-right
  right: 0
  padding-right: 0px
  border-radius: 25px 0px 0px 25px
  label
    border-radius: 25px 0px 0px 25px
    padding: 4px
    width: 100%
    margin-bottom: auto
  input[type="radio"]
    border-radius: 25px 0px 0px 25px
  .colors
    width: 40px
    height: 40px
    border-radius: 64px
</style>
